import { Routes } from '@angular/router';
import { skipVisitRoutes } from './skip-visit/skip-visit.routes';
import { InviteRoutes } from '../account/invite/invite.routes';

export const getCareRoutes: Routes = [
  {
    path: '',
    children: [
      {
        path: '',
        loadComponent: () => import('./select-account/select-account.page').then((m) => m.SelectAccountPage),
        data: {
          background: 'assets/splash_bck.png',
        },
      },
      {
        path: 'invite',
        loadComponent: () => import('../account/invite/invite.page').then((m) => m.InvitePage),
        children: InviteRoutes,
      },
    ],
  },
  {
    path: 'enter-symptoms',
    loadComponent: () => import('./enter-symptoms/enter-symptoms.component').then((m) => m.EnterSymptomsComponent),
    data: {
      background: 'assets/splash_bck.png',
      shouldShowTabBar: false,
    },
  },
  {
    path: 'visit-options',
    loadComponent: () =>
      import('../../pages/visit-options/visit-options.component').then((m) => m.VisitOptionsComponent),
    data: {
      background: 'assets/splash_bck.png',
      shouldShowTabBar: false,
    },
  },
  {
    path: 'location-list',
    loadComponent: () =>
      import('../../pages/location-list/location-list.component').then((m) => m.LocationListComponent),
    data: {
      background: 'assets/splash_bck.png',
      shouldShowTabBar: false,
    },
  },
  {
    path: 'off-hours',
    loadComponent: () => import('./in-person/off-hours/off-hours.component').then((m) => m.OffHoursComponent),
    data: {
      shouldShowTabBar: false,
    },
  },
  {
    path: 'skip-visit',
    children: skipVisitRoutes,
    data: {
      shouldShowTabBar: false,
    },
  },
  {
    path: 'select-chief-concern',
    loadComponent: () =>
      import('./select-chief-concern/select-chief-concern.component').then((m) => m.SelectChiefConcernComponent),
    data: {
      background: 'assets/splash_bck.png',
      shouldShowTabBar: false,
    },
  },
  {
    path: 'schedule-confirmation',
    loadComponent: () =>
      import('./get-care-schedule-confirmation/get-care-schedule-confirmation.page').then(
        (m) => m.GetCareScheduleConfirmationPage,
      ),
    data: {
      background: 'assets/splash_bck.png',
      shouldShowTabBar: false,
    },
  },
  {
    path: 'visit-blocker',
    loadComponent: () => import('./visit-blocker/visit-blocker.component').then((m) => m.VisitBlockerComponent),
    data: {
      background: 'assets/splash_bck.png',
      shouldShowTabBar: false,
    },
  },
  {
    path: 'failed-payment',
    loadComponent: () =>
      import('./get-care-failed-payment/get-care-failed-payment.page').then((m) => m.GetCareFailedPaymentPage),
    data: {
      background: 'assets/splash_bck.png',
      shouldShowTabBar: false,
    },
  },
];
